import { useState } from 'react';

export class PrizeWheelController {
  constructor(items, onEnd) {
    this.items = items || [];
    this.onEnd = onEnd;
    this.targetIndex = 0;
    this.shouldSpin = false;
    this.isSpinning = false;
    this.setItems = this.setItems.bind(this);
    this.spin = this.spin.bind(this);
    this.handleSpinEnd = this.handleSpinEnd.bind(this);
    this.setIsSpinning = this.setIsSpinning.bind(this);
  }

  setItems(newItems) {
    this.items = newItems;
  }

  spin(targetIndex) {
    console.log('spin', targetIndex);
    this.targetIndex = targetIndex;
    this.shouldSpin = true;
    setTimeout(() => {
      this.shouldSpin = false;
    }, 0);
  }

  handleSpinEnd() {
    this.isSpinning = false;
    setTimeout(() => {
      if (this.onEnd && this.items[this.targetIndex]) {
        this.onEnd(this.items[this.targetIndex]);
      }
    }, 500);
  }

  setIsSpinning(isSpinning) {
    this.isSpinning = isSpinning;
  }

  get selectedItem() {
    return this.items[this.targetIndex];
  }
}

export const usePrizeWheelController = (items, onEnd) => {
  const [controller] = useState(new PrizeWheelController(items, onEnd));
  return controller;
};